const { REACT_APP_AIRTABLE_API_KEY } = process.env

export const GLOSSARY_API_DETAILS = {
    URL: 'https://api.airtable.com/v0/appsJDi2s5AKLyf5z/Glossary%20Data',
    KEY: REACT_APP_AIRTABLE_API_KEY,
};
  